import http from '../utils/http';
import Event from '../view-model/analytics/Event';

const send = ({ user, ...data }: Event) =>
    http.post<null>(`/v2.1/users/${user}/events`, data).catch(console.error);

const analyticsService = { send };

export default analyticsService;
